import React, { Fragment, useState } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import FormCad from '../../../../components/auth/veiculos/form_cad'


function CadastrarVeiculosScreen() {

    return (
        <Fragment>
            <Head titulo="Cadastrar Veículo na Frota Municipal" />
            <HeaderLogged />
            <Container>
               <FormCad />
            </Container>
            <Footer />
        </Fragment>
    );
}

export default CadastrarVeiculosScreen;